import React from "react";
import PropTypes from "prop-types";
import "./UsedVehiclePanels.scss";
import { TabContent, TabPane } from "reactstrap";
import { FormatAsDollars } from "../../../utils/Helpers/Format";
import { Link } from "react-router-dom";
import sortIncentives from "../../../functions/incentives/Sort/sortIncentives";
import SelectVehicleYearFilter from "../../InputComponents/SelectVehicleYearFilter/SelectVehicleYearFilter";
import { FormattedMessage } from "react-intl";
import SmoothScroll from "../../../utils/Helpers/SmoothScroll";

const UsedVehiclePanels = ({ cars, car, setUsedEv }) => {
  if (!cars) return null;

  const usedIncentives = car.incentives.filter(
    (incentive) => incentive.applicable_to_used_vehicles
  );

  const totalSavings = sortIncentives(usedIncentives).total("eligible-rebates");

  const renderAfterIncentives = () => {
    const minPrice = FormatAsDollars(car.lowerBoundMsrp - totalSavings);
    const maxPrice = FormatAsDollars(car.upperBoundMsrp - totalSavings);

    return (
      <div className="price-range">
        <div className="price">{minPrice}</div>
        <div className="divider">-</div>
        <div className="price">{maxPrice}</div>
      </div>
    );
  };

  return (
    <>
      <div className="PricePanels">
        <TabContent activeTab={"1"}>
          <TabPane tabId="1">
            <div className="row">
              <div className="col-sm-12">
                <div className="PanelItem">
                  <SelectVehicleYearFilter
                    car={car}
                    vehicles={cars}
                    setUsedEv={setUsedEv}
                  />
                </div>
                <div className="PanelItem text-center">
                  <div className="PanelItemTop">
                    <p className="RenderItemTitle text-center">
                      <FormattedMessage
                        id="vehicle.afterIncentives"
                        defaultMessage="After Incentives"
                        description="Price Panel After Incentives"
                      />
                    </p>
                    <div className="h1">{renderAfterIncentives()}</div>
                    <p
                      className="text-center"
                      style={{ color: "#EB1700", fontWeight: 400 }}
                      onClick={(e) => SmoothScroll("EVIncentives")}
                    >
                      See all incentives &#62;
                    </p>
                  </div>
                </div>
                {/* <div className="PanelItem text-center">
                  <div className="PanelItemTop">
                    <p className="RenderItemTitle text-center">
                      <FormattedMessage
                        id="vehicle.estimatedIncentives"
                        defaultMessage="ESTIMATED INCENTIVES"
                        description="Estimated Incentives"
                      />
                    </p>
                    <p className="h1 text-center">
                      {FormatAsDollars(totalSavings)}
                    </p>
                  </div>
                </div> */}
                <div className="PanelItem text-center">
                  <Link to={`/compare-vehicles?${car.handle}`}>
                    <button
                      style={{
                        borderRadius: "1000px",
                        backgroundColor: "#EB1700",
                      }}
                      className="btn-ae-custom-two"
                    >
                      Compare
                    </button>
                  </Link>
                </div>
              </div>
            </div>
          </TabPane>
        </TabContent>
      </div>
    </>
  );
};

export default UsedVehiclePanels;

UsedVehiclePanels.propTypes = {
  car: PropTypes.object,
  paymentDetails: PropTypes.object,
};
